<template>
  <div class="relatorios-view">
    <!-- Container de cards lado a lado -->
    <div class="d-flex flex-column flex-md-row gap-4 mb-4 align-items-start">
      <!-- CARD de CATEGORIAS -->
      <div class="dashboard-card flex-fill w-100 w-md-auto">
        <div class="icon-container" :style="{ backgroundColor: '#6c757d' }">
          <i class="bi bi-tag"></i>
        </div>
        <div class="content-container">
          <div class="card-title mb-2">Categoria</div>
          <div class="options d-flex flex-column">
            <label
              v-for="cat in categorias"
              :key="cat"
              class="form-check option-card mb-1"
              @click="selectedCategoria = cat"
            >
              <input
                class="form-check-input"
                type="radio"
                name="categoria"
                :value="cat"
                v-model="selectedCategoria"
              />
              <span class="form-check-label">{{ cat }}</span>
            </label>
          </div>
        </div>
      </div>

      <!-- CARD de RELATÓRIOS -->
      <div
        class="dashboard-card flex-fill w-100 w-md-auto"
        v-if="selectedCategoria"
      >
        <div class="icon-container" :style="{ backgroundColor: '#0d6efd' }">
          <i class="bi bi-file-earmark-text"></i>
        </div>
        <div class="content-container">
          <div class="card-title mb-2">Relatório</div>
          <div class="options d-flex flex-column">
            <label
              v-for="rel in relatoriosPorCategoria[selectedCategoria] || []"
              :key="rel.key"
              class="form-check option-card mb-1"
              :class="{ 'option-card-disabled': rel.feature && !hasFeature(rel.feature) }"
              :title="rel.feature && !hasFeature(rel.feature) ? getFeatureMessage(rel.feature) : ''"
              @click.prevent="selectRelatorio(rel)"
            >
              <input
                class="form-check-input"
                type="radio"
                name="relatorio"
                :value="rel.key"
                :checked="selectedRelatorio === rel.key"
                :disabled="rel.feature && !hasFeature(rel.feature)"
                @click.prevent
              />
              <span class="form-check-label">
                {{ rel.label }}
                <i
                  v-if="rel.feature && !hasFeature(rel.feature)"
                  class="bi bi-lock-fill ms-2"
                ></i>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- RENDERIZA O COMPONENTE SELECIONADO -->
    <component
      v-if="selectedRelatorio && componentMap[selectedRelatorio]"
      :is="componentMap[selectedRelatorio]"
      class="border p-3 rounded"
    />
    <div v-else class="text-muted">
      {{ categorias.length ? 'Selecione um relatório acima.' : 'Nenhum relatório autorizado.' }}
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, getCurrentInstance } from 'vue'
import { relatoriosAccess } from '@/utils/relatoriosAccess'

// imports dos componentes existentes
import AlunosAniversariantes                 from '@/components/Gestao/Relatorios/Cadastrais/AlunosAniversariantes.vue'
import AlunosAtivos                          from '@/components/Gestao/Relatorios/Cadastrais/AlunosAtivos.vue'
import AlunosInativos                        from '@/components/Gestao/Relatorios/Cadastrais/AlunosInativos.vue'
import AnalisePorRefil                       from '@/components/Gestao/Relatorios/Despesas/AnalisePorRefil.vue'
import APagar                                from '@/components/Gestao/Relatorios/Despesas/APagar.vue'
import PorPeriodo                            from '@/components/Gestao/Relatorios/Despesas/PorPeriodo.vue'
import PagasPorVencimento                    from '@/components/Gestao/Relatorios/Despesas/PagasPorVencimento.vue'
import PagasPorPagamento                     from '@/components/Gestao/Relatorios/Despesas/PagasPorPagamento.vue'
import FechamentoDiario                      from '@/components/Gestao/Relatorios/Financeiros/FechamentoDiario.vue'
import ReceitasDespesas                      from '@/components/Gestao/Relatorios/Financeiros/ReceitasDespesas.vue'
import ExtratoMensalidadesMatriculas         from '@/components/Gestao/Relatorios/Financeiros/ExtratoMensalidadesMatriculas.vue'
// novo import do componente de conciliação
import ConciliacaoBancaria                   from '@/components/Gestao/Relatorios/Financeiros/ConciliacaoBancaria.vue'
import ReceitasReceber                       from '@/components/Gestao/Relatorios/Receitas/ReceitasReceber.vue'
import ReceitasRecebidasRecebimento          from '@/components/Gestao/Relatorios/Receitas/ReceitasRecebidasRecebimento.vue'
import ReceitasRecebidasVencimento           from '@/components/Gestao/Relatorios/Receitas/ReceitasRecebidasVencimento.vue'

import AlunosQuedas                          from '@/components/Gestao/Relatorios/Operacionais/AlunosQuedas.vue'
import AlunosPorTurma                        from '@/components/Gestao/Relatorios/Operacionais/AlunosPorTurma.vue'
import ExperimentaisMatriculas               from '@/components/Gestao/Relatorios/Operacionais/ExperimentaisMatriculas.vue'
import AvaliacoesAlunos                      from '@/components/Gestao/Relatorios/Operacionais/AvaliacoesAlunos.vue'
import ChamadasInstrutor from '@/components/Gestao/Relatorios/Operacionais/ChamadasInstrutor.vue'
import CavalosXAulas                         from '@/components/Gestao/Relatorios/Operacionais/CavalosXAulas.vue'
import EstoqueProdutos                       from '@/components/Gestao/Relatorios/Operacionais/EstoqueProdutos.vue'
import GradeHorariaProfessor                 from '@/components/Gestao/Relatorios/Operacionais/GradeHorariaProfessor.vue'
import MatriculasNovasAnual                  from '@/components/Gestao/Relatorios/Operacionais/MatriculasNovasAnual.vue'
import ProspeccaoMatriculas                  from '@/components/Gestao/Relatorios/Operacionais/ProspeccaoMatriculas.vue'
import RetornosRenovacoes                    from '@/components/Gestao/Relatorios/Operacionais/RetornosRenovacoes.vue'
import ControleMensal                        from '@/components/Gestao/Relatorios/Operacionais/ControleMensal.vue'
import TabelaValoresPlanos                   from '@/components/Gestao/Relatorios/Operacionais/TabelaValoresPlanos.vue'


import RelatorioDre                          from '@/components/Gestao/Relatorios/Financeiros/RelatorioDre.vue'
import RelatorioPdr                          from '@/components/Gestao/Relatorios/Financeiros/RelatorioPdr.vue'
import ReceitasPorRefil                      from '@/components/Gestao/Relatorios/Receitas/ReceitasPorRefil.vue'
import ReceitasPorPeriodo                    from '@/components/Gestao/Relatorios/Receitas/ReceitasPorPeriodo.vue'
import ReceitasPendencias                    from '@/components/Gestao/Relatorios/Financeiros/ReceitasPendencias.vue'
import ControleVencimentosPlanos             from '@/components/Gestao/Relatorios/Operacionais/ControleVencimentosPlanos.vue'
import ProvasEscola                          from '@/components/Gestao/Relatorios/Financeiros/ProvasEscola.vue'

const { proxy } = getCurrentInstance()
const globalState = proxy.$globalState

function hasFeature(featureKey) {
  if (!featureKey) return true
  if (!globalState.featuresLoaded) return true
  return !!globalState.featureFlags?.[featureKey]?.enabled
}

function getFeatureMessage(featureKey) {
  return globalState.featureFlags?.[featureKey]?.message || 'Módulo exclusivo para o Plano Performance'
}

function selectRelatorio(rel) {
  if (!(relatoriosPorCategoria.value[selectedCategoria.value] || []).some(item => item.key === rel.key)) return
  if (rel.feature && !hasFeature(rel.feature)) {
    if (typeof proxy.$alert === 'function') {
      proxy.$alert(getFeatureMessage(rel.feature), 'Plano')
    } else {
      alert(getFeatureMessage(rel.feature))
    }
    return
  }

  selectedRelatorio.value = rel.key
}

// dados
const catalogoRelatorios = {
  Cadastrais: [
    { key: 'alunos-aniversariantes', label: 'Alunos Aniversariantes', component: AlunosAniversariantes },
    { key: 'alunos-ativos',          label: 'Matrículas Ativas',          component: AlunosAtivos },
    { key: 'alunos-inativos',        label: 'Matrículas Inativas',   component: AlunosInativos }, // <-- novo
  ],
  Despesas: [
    { key: 'analise-por-refil',            label: 'Análise por Refil',    component: AnalisePorRefil },
    { key: 'despesas-a-pagar',             label: 'Despesas a Pagar',     component: APagar },
    { key: 'despesas-por-periodo',         label: 'Por Período',          component: PorPeriodo },
    { key: 'despesas-pagas-por-vencimento',label: 'Pagas por Vencimento', component: PagasPorVencimento },
    { key: 'despesas-pagas-por-pagamento', label: 'Pagas por Pagamento',  component: PagasPorPagamento },
  ],
  Financeiros: [
    { key: 'fechamento-diario',               label: 'Fechamento Diário',               component: FechamentoDiario },
    { key: 'receitas-despesas',               label: 'Receitas X Despesas',             component: ReceitasDespesas },
    { key: 'provas-escola',                   label: 'Provas x Escola',                 component: ProvasEscola },
    { key: 'extrato-mensalidades-matriculas', label: 'Extrato Mensalidades/Matrículas', component: ExtratoMensalidadesMatriculas },
    // conciliação bancária adicionado
    { key: 'conciliacao-bancaria',            label: 'Conciliação Bancária',            component: ConciliacaoBancaria },
    { key: 'dre',                             label: 'DRE Mensal',                      component: RelatorioDre },
    { key: 'pdr',                             label: 'PDR - Previsão de Resultados',    component: RelatorioPdr },
    { key: 'receitas-pendencias',             label: "Pendências (FP - A informar)",    component: ReceitasPendencias }, // <— novo

  ],
  Receitas: [
    { key: 'receitas-por-refil',              label: 'Análise de Receitas por Refil', component: ReceitasPorRefil },
    { key: 'receitas-receber',                label: 'Receitas a Receber',            component: ReceitasReceber },
    { key: 'receitas-por-periodo',            label: 'Receitas por Período',          component: ReceitasPorPeriodo },
    { key: 'receitas-recebidas-recebimento',  label: 'Recebidas (Recebimento)',       component: ReceitasRecebidasRecebimento },
    { key: 'receitas-recebidas-vencimento',   label: 'Recebidas (Vencimento)',        component: ReceitasRecebidasVencimento },
  ],
  Operacionais: [
    { key: 'alunos-por-turma',                label: 'Alunos Por Turma x Instrutor',             component: AlunosPorTurma },
    {
      key: 'aulas-experimentais-matriculas',
      label: 'Aulas Experimentais => Matrículas',
      component: ExperimentaisMatriculas,
      feature: 'RELATORIO_AULAS_EXPERIMENTAIS_MATRICULAS'
    },
    { key: 'avaliacao-operacional',           label: 'Avaliação (Realizaram / Não realizaram)',  component: AvaliacoesAlunos },
    { key: 'chamadas-instrutor', label: 'Chamadas x Instrutor', component: ChamadasInstrutor },
    { key: 'cavalos-aulas',                   label: 'Cavalos x Aulas',                          component: CavalosXAulas },
    { key: 'controle-vencimentos-planos',     label: 'Controle de Vencimentos de Planos',        component: ControleVencimentosPlanos },
    {
      key: 'controle-mensal',
      label: 'Controle Mensal',
      component: ControleMensal,
      feature: 'RELATORIO_CONTROLE_MENSAL'
    },
    {
      key: 'estoque-produtos',
      label: 'Estoque de Produtos',
      component: EstoqueProdutos,
      feature: 'RELATORIO_ESTOQUE_PRODUTOS'
    },
    { key: 'grade-horaria-professor',         label: 'Grade Horária do Professor x Qtd. Alunos', component: GradeHorariaProfessor },
    { key: 'matriculas-novas-anual',          label: 'Matrículas Novas (Anual)',                 component: MatriculasNovasAnual },
    {
      key: 'prospeccao-matriculas',
      label: 'Prospects que Geraram Matrícula',
      component: ProspeccaoMatriculas,
      feature: 'RELATORIO_PROSPECCAO_MATRICULAS'
    },
    { key: 'alunos-quedas',                   label: 'Registro de Quedas',                       component: AlunosQuedas },
    { key: 'retornos-renovacoes',             label: 'Retornos x Renovações',                    component: RetornosRenovacoes },
    { key: 'tabela-valores-planos',           label: 'Tabela de valores de planos',              component: TabelaValoresPlanos },
]
}

const relatoriosPorCategoria = computed(() => {
  const acesso = relatoriosAccess(globalState)
  return Object.fromEntries(Object.entries(catalogoRelatorios).map(([categoria, relatorios]) => [
    categoria, relatorios.filter(rel => acesso.permite(categoria, rel.key)),
  ]))
})
const categorias = computed(() => Object.keys(relatoriosPorCategoria.value)
  .filter(categoria => relatoriosPorCategoria.value[categoria].length))

const selectedCategoria = ref('')
const selectedRelatorio = ref('')

watch(selectedCategoria, () => {
  selectedRelatorio.value = ''
})

const componentMap = computed(() => Object
  .values(relatoriosPorCategoria.value)
  .flat()
  .reduce((map, { key, component }) => {
    map[key] = component
    return map
  }, {}))
</script>

<style scoped>
/* Wrapper: cards alinhados no topo */
.d-flex.align-items-start { display: flex; gap: 1rem; align-items: flex-start; }
.dashboard-card.flex-fill { flex: 1; display: flex; flex-direction: row; background-color: #fff; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); overflow: hidden; height: auto; }
.d-flex.gap-4 { display: flex; gap: 1rem; }
.dashboard-card { display: flex; background-color: #fff; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); overflow: hidden; height: auto; }
.icon-container { width: 65px; display: flex; align-items: center; justify-content: center; }
.icon-container i { font-size: 1.5rem; color: #fff; }
.content-container { padding: 0.75rem 1rem; }
.card-title { font-size: 0.95rem; font-weight: 600; color: #333; margin-bottom: 0.5rem; }
.options .form-check-label { font-size: 0.8rem; line-height: 1.4; }
.option-card + .option-card { margin-top: 0; }
.options { display: flex; flex-direction: column; }
.option-card { cursor: pointer; padding: 0rem 1.2rem; border-radius: 0.25rem; transition: background-color .2s; }
.option-card:hover { background-color: #f1f1f1; }
.option-card .form-check-input { margin-right: 0.5rem; }

@media (max-width: 768px) {
  .d-flex.gap-4 { flex-direction: column; }
  .dashboard-card.flex-fill { flex: 0 0 100%; width: 100%; }
}

.option-card-disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.option-card-disabled:hover {
  background-color: #f1f1f1;
}

</style>
